import styled from "styled-components";

const ProductFavorite = styled.div`
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
`;
export default ProductFavorite;
